import { ErrorMessage } from 'formik';
import React from 'react';
import { Argument } from 'classnames';
import ZenErrorMessage from './ZenErrorMessage';

export interface FormikErrorMessageProps {
    name: string;
    className?: Argument[];
}

function FormikErrorMessage({ name, className }: FormikErrorMessageProps) {
    return (
        <ErrorMessage
            name={name}
            render={(msg) => {
                return <ZenErrorMessage className={className} message={msg} />;
            }}
        />
    );
}

export default FormikErrorMessage;
